import React from 'react';

import { ConstantPermissions } from 'contexts/useConstant';
import PendingPaymentReceived from 'components/Tvendo/Bank/Operations/Payments/PendingPaymentSharedFile.js';

export default function () {
  return (
    <PendingPaymentReceived
      title="Listado de clientes pendientes de pagos"
      excelName="Clientes-pendientes-pago"
      entity="sap/business-partner/debtors"
      permission={ConstantPermissions.PYMT_RECEIVED_PAYMENTS_STORE}
    />
  );
}
